import { Injectable, Signal } from '@angular/core';
import { IEmploymentData, IEmploymentModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { EmploymentActions, EmploymentSelectors, IEmploymentState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class EmploymentStore extends StateAccessService<IEmploymentState> {
  readonly state$: Observable<IEmploymentState>;

  readonly data$$: Signal<IEmploymentData>;
  readonly model$$: Signal<IEmploymentModel>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(EmploymentSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(EmploymentSelectors.data);
  }

  dispatchEmploymentReset() {
    this.stateFacade.dispatch(EmploymentActions.reset());
  }
  dispatchUpdateModel({ model }: { model: IEmploymentModel }) {
    this.stateFacade.dispatch(EmploymentActions.updateModel({ model }));
  }
  dispatchEmploymentLoad() {
    this.stateFacade.dispatch(EmploymentActions.load());
  }
  dispatchEmploymentLoadSuccess({ model, data }: { model: IEmploymentModel; data: IEmploymentData }) {
    this.stateFacade.dispatch(EmploymentActions.loadSuccess({ model, data }));
  }
  dispatchEmploymentSubmit() {
    this.stateFacade.dispatch(EmploymentActions.submit());
  }
  dispatchEmploymentSubmitSuccess({ model, data }: { model: IEmploymentModel; data: IEmploymentData }) {
    this.stateFacade.dispatch(EmploymentActions.submitSuccess({ model, data }));
  }
}
